export default __webpack_public_path__ + "static/media/logo-small.453eb0f9.png";